import * as Yup from "yup";

export interface PortalSettingRule {
  id?: string;
  settingTitle: string;
  hideParts: boolean;
  hidePrice: boolean;
  priceReplacementText?: string | null;
  hideCartButton: boolean;
  cartReplacementText?: string | null;
  status: boolean;
  applyOnAllParts: boolean;
  manufacturers: string[];
  partNumbers: string[];
}

export enum RuleActionType {
  Delete,
  Enable,
  Disable,
}

export const SettingRuleInitialValues: PortalSettingRule = {
  id: "",
  settingTitle: "",
  hideParts: false,
  hidePrice: false,
  priceReplacementText: "",
  hideCartButton: false,
  cartReplacementText: "",
  status: true,
  applyOnAllParts: false,
  manufacturers: [],
  partNumbers: [],
};
export const SettingRuleValidationSchema = Yup.object().shape({
  settingTitle: Yup.string().required("Please add title"),
  status: Yup.boolean().required("Please select Status"),
});
